import axios, { AxiosRequestConfig } from 'axios';
import { PagedResponse } from '../types/api';
import { Language } from '../types/Language';

const URL = '/v2/languages';

class LanguageService {
  static getByFilter(config?: AxiosRequestConfig): Promise<PagedResponse<Language>> {
    return axios.get(URL, config);
  }
}

export { LanguageService };
